import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { onMount } from "svelte";
import { SvelteSet } from "svelte/reactivity";
import { getStationCoords, getCachedCoords } from "../utils/station-coords.js";
import { describeFetchProgress, describeRetryWait } from "../utils/progress-message.js";

var root = $.from_html(`<div class="status-message svelte-1apnbj7"> </div>`);
var root_1 = $.from_html(`<div class="status-messages svelte-1apnbj7" aria-live="polite" aria-atomic="true"></div>`);
var root_2 = $.from_html(`<div class="status-messages fetch-progress svelte-1apnbj7" aria-live="off"><div class="status-message svelte-1apnbj7"> </div> <!></div>`);
var root_3 = $.from_html(`<div role="status" aria-live="polite" class="no-departures svelte-1apnbj7"><!> <!></div>`);
var root_4 = $.from_html(`<span class="direction-header-text svelte-1apnbj7"><a class="direction-header-link svelte-1apnbj7" target="_blank" rel="noopener noreferrer"> </a></span> <div class="direction-header-time status-header-item svelte-1apnbj7" id="datetime-display"> </div>`, 1);
var root_5 = $.from_html(`<a class="direction-header-link svelte-1apnbj7" target="_blank" rel="noopener noreferrer"> </a>`);
var root_6 = $.from_html(`<div class="departure-row svelte-1apnbj7" role="status" aria-live="polite"><div class="no-departures svelte-1apnbj7"> </div></div>`);
var root_7 = $.from_svg(`<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 25 25" class="route-icon" aria-hidden="true"><rect fill="#00508c" width="25" height="25"></rect><path fill="#fff" d="M20.9,2h-5v13.1c0,2.4-.8,4.1-3.4,4.1s-3.5-1.7-3.5-4.1V2h-4.9v13.5c0,5.7,4.6,7.8,8.4,7.8s8.4-2.1,8.4-7.8V2s0,0,0,0Z"></path></svg>`);
var root_8 = $.from_svg(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.98 31.98" class="route-icon" aria-hidden="true"><path d="M15.99,0A15.99,15.99,0,1,0,31.98,15.99,16.023,16.023,0,0,0,15.99,0" fill="#009551" fill-rule="evenodd"></path><path d="M25.67,6.31c0,4.74-.04,4.66-.04,4.66C23.29,8.68,14.77,5.05,13.08,7.86c-1.99,3.31,4.32,4.53,9.48,6.29,6.15,2.1,6.06,9.19,1.58,12.61-5.93,4.52-13.23,2.38-18.69-1.71V20.16c1.3,1.52,3.44,2.52,6.47,3.61,1.72.62,6.13,1.59,7.26-.41,1.52-2.69-2.43-3.54-4.02-3.83a16.155,16.155,0,0,1-6.35-2.44c-4.64-3.07-4.42-9.04.11-12.23C14,1.27,21.12,2.52,25.67,6.31" fill="#fff" fill-rule="evenodd"></path></svg>`);
var root_9 = $.from_svg(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="route-icon" aria-hidden="true"><rect width="32" height="32" fill="#dd0b2f"></rect><path d="M18.9,11.8h2.01v1.38a2.719,2.719,0,0,1,2.43-1.59a1.758,1.758,0,0,1,1.13.36A2.972,2.972,0,0,1,25.24,13a2.567,2.567,0,0,1,2.38-1.41a1.847,1.847,0,0,1,1.62.79a3.47,3.47,0,0,1,.5,2.02v4.81H27.56V15.39c0-1.13-.32-1.7-.97-1.7a1,1,0,0,0-.92.68a3.158,3.158,0,0,0-.25,1.33v3.5H23.23V15.16c0-.99-.32-1.48-.96-1.48a1.013,1.013,0,0,0-.94.76a3.694,3.694,0,0,0-.24,1.4V19.2H18.9V11.8m-3.73,4.06a1.611,1.611,0,0,0-.87.23a1.005,1.005,0,0,0-.19,1.53.829.829,0,0,0,.62.25a1.107,1.107,0,0,0,.99-.6a2.53,2.53,0,0,0,.32-1.3l-.01-.04C15.54,15.88,15.25,15.86,15.17,15.86Zm.84-1.28v-.21a1.018,1.018,0,0,0-.51-.89a1.785,1.785,0,0,0-.95-.28a5.384,5.384,0,0,0-1.91.57V12.1a5.613,5.613,0,0,1,2.38-.47q3.045,0,3.04,3.19v4.4H16.18V18.09a4.924,4.924,0,0,1-.94,1a2.094,2.094,0,0,1-1.24.32a2.081,2.081,0,0,1-1.6-.71a2.6,2.6,0,0,1-.64-1.83a2,2,0,0,1,1.58-2.07A10.788,10.788,0,0,1,16.01,14.58ZM9.13,11.8l.06,1.51a3.412,3.412,0,0,1,.68-1.18a1.556,1.556,0,0,1,1.14-.42c.09,0,.32.03.69.07l-.05,2.18a2.9,2.9,0,0,0-.79-.1c-1,0-1.5.77-1.5,2.3v3.07H7.17V13.7c0-.31-.02-.95-.06-1.91H9.13ZM1.3,9.37H7.71v1.97H5.66V19.2H3.4V11.34H1.3Z" fill="#fff" fill-rule="evenodd"></path></svg>`);
var root_10 = $.from_svg(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92.81 122.88" class="route-icon" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M66.69,101.35H26.68l-4.7,6.94h49.24L66.69,101.35L66.69,101.35z M17.56,114.81l-5.47,8.07H0l19.64-29.46 h-3.49c-4.76,0-8.66-3.9-8.66-8.66V8.66C7.5,3.9,11.39,0,16.15,0h61.22c4.76,0,8.66,3.9,8.66,8.66v76.1c0,4.76-3.9,8.66-8.66,8.66 h-3.4l18.83,29.04H80.45l-4.99-7.65H17.56L17.56,114.81z M62.97,67.66h10.48c1.14,0,2.07,0.93,2.07,2.07V80.2 c0,1.14-0.93,2.07-2.07,2.07H62.97c-1.14,0-2.07-0.93-2.07-2.07V69.72C60.9,68.59,61.83,67.66,62.97,67.66L62.97,67.66z M18.98,67.66h10.48c1.14,0,2.07,0.93,2.07,2.07V80.2c0,1.14-0.93,2.07-2.07,2.07H18.98c-1.14,0-2.07-0.93-2.07-2.07V69.72 C16.91,68.59,17.84,67.66,18.98,67.66L18.98,67.66z M25.1,16.7h42.81c4.6,0,8.36,3.76,8.36,8.37v13.17c0,4.6-3.76,8.36-8.36,8.36 H25.1c-4.6,0-8.36-3.76-8.36-8.36V25.07C16.74,20.47,20.5,16.7,25.1,16.7L25.1,16.7z M38.33,3.8h16.2C55.34,3.8,56,4.46,56,5.27 v6.38c0,0.81-0.66,1.47-1.47,1.47h-16.2c-0.81,0-1.47-0.66-1.47-1.47V5.27C36.85,4.46,37.51,3.8,38.33,3.8L38.33,3.8z"></path></svg>`);
var root_11 = $.from_svg(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="route-icon" aria-hidden="true"><path d="M16,0A16,16,0,1,1,0,16,16.034,16.034,0,0,1,16,0" fill="#005d79" fill-rule="evenodd"></path><path d="M28.43,12.85a7.084,7.084,0,0,0-2.25-.56q-1.68,0-1.68,1.08c0,.46.39.84,1.18,1.15a10.3,10.3,0,0,1,2.21,1.02a3.178,3.178,0,0,1,1.19,2.7a3.2,3.2,0,0,1-1.33,2.8a4.846,4.846,0,0,1-2.85.78a10.854,10.854,0,0,1-3.09-.57l.23-2.38a6.584,6.584,0,0,0,2.69.7c1.08,0,1.62-.37,1.62-1.12,0-.51-.4-.93-1.19-1.27a16.466,16.466,0,0,1-2.2-1.03a2.906,2.906,0,0,1-1.19-2.49A3.1,3.1,0,0,1,23.1,10.9a4.932,4.932,0,0,1,2.83-.73a11.091,11.091,0,0,1,2.7.45l-.2,2.23M12.35,10.47h2.62v7.04a2.58,2.58,0,0,0,.4,1.52a1.476,1.476,0,0,0,1.26.62c1.03,0,1.55-.81,1.55-2.43V10.47h2.63V17.6a4.05,4.05,0,0,1-1.28,3.2a4.48,4.48,0,0,1-3.05,1.02a4.185,4.185,0,0,1-2.85-1a3.709,3.709,0,0,1-1.28-2.96Zm-4.8,9.04a1.2,1.2,0,0,0,.88-.38a1.274,1.274,0,0,0,.38-.94c0-.84-.55-1.27-1.65-1.27H6.06V19.5H7.55Zm-.53-4.57a1.771,1.771,0,0,0,1.02-.28A1.129,1.129,0,0,0,8.1,12.8a1.521,1.521,0,0,0-.93-.3H6.05v2.45h.97ZM3.47,10.45H8a3.514,3.514,0,0,1,2.13.62a2.454,2.454,0,0,1,1,2.12a3.087,3.087,0,0,1-.41,1.71a2.761,2.761,0,0,1-1.33.99a2.506,2.506,0,0,1,2.02,2.72q0,2.97-4.07,2.97H3.46V10.45Z" fill="#fff" fill-rule="evenodd"></path></svg>`);
var root_12 = $.from_html(`<!> <span class="route-line-text svelte-1apnbj7"> </span>`, 1);
var root_13 = $.from_html(`<span> </span>`);
var root_14 = $.from_html(`<span class="delay-amount svelte-1apnbj7" aria-hidden="true"> </span>`);
var root_15 = $.from_html(` <!>`, 1);
var root_16 = $.from_html(`<li role="listitem"><div class="route-container svelte-1apnbj7" aria-hidden="true"><span class="route-number svelte-1apnbj7"><!></span> <span class="destination svelte-1apnbj7"><span class="destination-text svelte-1apnbj7"> </span></span></div> <div class="time-container svelte-1apnbj7" aria-hidden="true"><span> </span> <span><!></span></div> <span class="sr-only svelte-1apnbj7"> </span></li>`);
var root_17 = $.from_html(`<ul role="list"></ul>`);
var root_18 = $.from_html(`<div class="direction-group svelte-1apnbj7"><h2 class="direction-header svelte-1apnbj7"><!></h2> <!></div>`);

const $$css = {
	hash: 'svelte-1apnbj7',
	code: '.no-departures.svelte-1apnbj7 {width:100%;text-align:center;font-size:1.75rem;color:#9ca3af;padding:0.4rem 0;font-style:italic;}.status-messages.svelte-1apnbj7 {display:inline-flex;flex-direction:column;gap:0.5rem;font-style:normal;color:#6b7280;}.status-message.svelte-1apnbj7 {font-size:1.25rem;line-height:1.4;}.fetch-progress.svelte-1apnbj7 .status-message:where(.svelte-1apnbj7) {\n    /* Keep the counters from jittering as they tick. */font-variant-numeric:tabular-nums;}.direction-group.svelte-1apnbj7 {width:100%;}.direction-header.svelte-1apnbj7 {font-size:var(--font-size-direction-header, 2.5rem);font-weight:700;margin:0.15rem 0 0.1rem 0;padding:0.25rem 0.75rem;border-bottom:2px solid rgba(0, 0, 0, 0.2);opacity:0.85;display:flex;justify-content:space-between;align-items:center;gap:0.5rem;background-color:var(--banner-color, #087BC4);color:white;}.direction-header-text.svelte-1apnbj7 {flex:1;min-width:0;}.direction-header-link.svelte-1apnbj7 {color:inherit;text-decoration:none;cursor:pointer;}.direction-header-link.svelte-1apnbj7:hover {text-decoration:underline;}.direction-header-time.svelte-1apnbj7 {flex-shrink:0;margin-left:1em;white-space:nowrap;display:flex;align-items:center;line-height:1;font-size:var(--font-size-status-header, 1.875rem);}.departure-row.svelte-1apnbj7 {display:flex;align-items:center;padding:0.2rem 0 0.2rem 0.75rem;border-bottom:1px solid rgba(0, 0, 0, 0.08);min-height:2.5rem;width:100%;box-sizing:border-box;}.departure-row.cancelled.svelte-1apnbj7 {opacity:0.5;text-decoration:line-through;}.departure-row.stale.svelte-1apnbj7 {opacity:0.5;\n    /* No strikethrough - just greyed out to signal staleness */}.route-container.svelte-1apnbj7 {flex:1 1 auto;display:grid;grid-template-columns:var(--route-column-width, 6.5em) 1fr;align-items:center;gap:0.3em;min-width:0;overflow:hidden;padding:0 0.75rem 0 0;}.route-number.svelte-1apnbj7 {font-weight:700;font-size:var(--font-size-route-number, 4rem);text-align:left;padding:0;min-width:0;white-space:nowrap;justify-self:start;display:flex;align-items:center;gap:0.3em;overflow:hidden;}.route-line-text.svelte-1apnbj7 {display:inline-block;min-width:0;}.route-line-text.clipped.svelte-1apnbj7 {\n    animation: scroll-destination 20s ease-in-out infinite;will-change:transform;}.route-number.svelte-1apnbj7:hover .route-line-text.clipped:where(.svelte-1apnbj7),\n  .route-number.svelte-1apnbj7:active .route-line-text.clipped:where(.svelte-1apnbj7) {animation-play-state:paused;}.route-badge.svelte-1apnbj7 {display:inline-flex;align-items:center;justify-content:center;padding:0.1em 0.3em;min-width:1.6em;font-weight:700;color:#fff;line-height:1;font-size:0.9em;}.route-badge-ubahn.svelte-1apnbj7 {background-color:#00508c;border-radius:0.15em;}.route-badge-sbahn.svelte-1apnbj7 {background-color:#009551;border-radius:50%;padding:0.15em 0.35em;}.route-badge-bus.svelte-1apnbj7 {background-color:#005d79;border-radius:50%;padding:0.15em 0.35em;}.route-badge-tram.svelte-1apnbj7 {background-color:#dd0b2f;border-radius:0.15em;}.route-badge-train.svelte-1apnbj7 {background-color:#6b7280;border-radius:0.25em;}.route-badge-regional.svelte-1apnbj7 {background-color:#6b7280;border-radius:0.25em;}.destination.svelte-1apnbj7 {overflow-x:hidden;overflow-y:hidden;white-space:nowrap;padding:0;min-width:0;font-size:var(--font-size-destination, 3.5rem);font-weight:500;text-align:left;justify-self:start;}.destination-text.svelte-1apnbj7 {display:inline-block;white-space:nowrap;}.time-container.svelte-1apnbj7 {flex:0 0 auto;display:grid;grid-template-columns:var(--platform-column-width, auto) var(--time-column-width, auto);align-items:center;padding:0 0.75rem 0 0.75rem;margin-right:0;gap:var(--time-container-gap, 0.75rem);width:var(--time-container-width, auto);}.platform.svelte-1apnbj7 {flex:0 0 auto;font-size:var(--font-size-platform, 2.5rem);font-weight:400;text-align:left;padding:0;white-space:nowrap;min-width:fit-content;color:#6b7280;}\n\n  /* A bus or tram stand instead of a rail platform: same column, dark yellow. */.platform.stand.svelte-1apnbj7 {color:#a16207;}.time.svelte-1apnbj7 {text-align:right;font-weight:600;font-size:var(--font-size-time, 4rem);white-space:nowrap;min-width:fit-content;overflow:hidden;transition:opacity 0.3s ease-in-out;}.time.delay.svelte-1apnbj7 {color:#d97706;}.time.realtime.svelte-1apnbj7 {color:#059669;}.delay-amount.svelte-1apnbj7 {color:#dc2626;font-size:var(--font-size-delay-amount, 2rem);font-weight:500;margin-left:0.5rem;}.sr-only.svelte-1apnbj7 {position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border-width:0;}'
};

export default function DeparturesList($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	let groupedDepartures = $.prop($$props, 'groupedDepartures', 19, () => []),
		unsupportedProviders = $.prop($$props, 'unsupportedProviders', 19, () => []),
		display = $.prop($$props, 'display', 3, undefined),
		isPageSuspended = $.prop($$props, 'isPageSuspended', 3, false),
		statusMessages = $.prop($$props, 'statusMessages', 19, () => []),
		progress = $.prop($$props, 'progress', 3, null);

	function formatTimeRelative(departure) {
		const now = new Date();
		const diffMs = departure.time.getTime() - now.getTime();
		const diffSeconds = Math.floor(diffMs / 1000);

		// Match Python: format_compact_duration logic
		if (diffSeconds < 0) {
			return "now";
		}

		if (diffSeconds < 60) {
			return "<1m"; // Match Python: if total_seconds < 60, return "<1m"
		}

		const diffMinutes = Math.floor(diffSeconds / 60);

		if (diffMinutes < 60) {
			return `${diffMinutes}m`;
		}

		const hours = Math.floor(diffMinutes / 60);
		const mins = diffMinutes % 60;

		if (mins === 0) {
			return `${hours}h`;
		}

		return `${hours}h${mins}m`;
	}

	function formatTimeAbsolute(departure) {
		const date = new Date(departure.time);
		const hours = date.getHours().toString().padStart(2, "0");
		const minutes = date.getMinutes().toString().padStart(2, "0");

		return `${hours}:${minutes}`;
	}

	function formatPlannedTimeRelative(departure) {
		if (!departure.plannedTime) {
			return formatTimeRelative(departure);
		}

		const now = new Date();
		const diffMs = departure.plannedTime.getTime() - now.getTime();
		const diffSeconds = Math.floor(diffMs / 1000);

		// Match Python: format_compact_duration logic
		if (diffSeconds < 0) {
			return "now";
		}

		if (diffSeconds < 60) {
			return "<1m"; // Match Python: if total_seconds < 60, return "<1m"
		}

		const diffMinutes = Math.floor(diffSeconds / 60);

		if (diffMinutes < 60) {
			return `${diffMinutes}m`;
		}

		const hours = Math.floor(diffMinutes / 60);
		const mins = diffMinutes % 60;

		if (mins === 0) {
			return `${hours}h`;
		}

		return `${hours}h${mins}m`;
	}

	function formatPlannedTimeAbsolute(departure) {
		if (!departure.plannedTime) {
			return formatTimeAbsolute(departure);
		}

		const date = new Date(departure.plannedTime);
		const hours = date.getHours().toString().padStart(2, "0");
		const minutes = date.getMinutes().toString().padStart(2, "0");

		return `${hours}:${minutes}`;
	}

	function getDelayMinutes(departure) {
		// Match Python version: has_delay = departure.delay_seconds is not None and departure.delay_seconds > 60
		// Only delays > 60 seconds (1 minute) are considered delays
		if (departure.delaySeconds != null && departure.delaySeconds > 60) {
			// Match Python: delay_minutes = departure.delay_seconds // 60 (integer division)
			return Math.floor(departure.delaySeconds / 60);
		}

		return null;
	}

	function hasDelay(departure) {
		// Match Python: has_delay = departure.delay_seconds is not None and departure.delay_seconds > 60
		return departure.delaySeconds != null && departure.delaySeconds > 60;
	}

	function getHeaderText(group) {
		// For stops without departures, header is just the stop name (matches Python template line 140: {{ stop_name }})
		if (group.departures.length === 0) {
			return group.stopName;
		}

		// Format: "StopName → DirectionName" (matches Python - no time suffix)
		// Strip "->" prefix from direction name (matches Python: direction_clean = group.direction_name.lstrip("->"))
		const directionClean = String(group.directionName ?? "").replace(/^->/, "").trim();

		if (!directionClean) {
			return group.stopName;
		}

		return `${group.stopName} → ${directionClean}`;
	}

	/**
	 * Rows whose times may be out of date: the page was suspended, or the stop
	 * behind them could not be refreshed, so they keep the departures they last
	 * had. Greyed out, never struck through - only a cancelled departure is.
	 */
	function showsStaleTimes(group) {
		return isPageSuspended() || group.refreshFailed === true;
	}

	/** What a screen reader hears before a group's rows: grey is invisible to it. */
	function rowListLabel(group) {
		const label = `Departures for ${group.directionName}`;

		return group.refreshFailed ? `${label}, not refreshed` : label;
	}

	/** Station coords cache (stationId -> { lat, lng }) for GPS map links. Populated by $effect. */
	let stationCoords = $.state($.proxy({}));

	$.user_effect(() => {
		const groups = groupedDepartures();
		const seen = new SvelteSet();

		for (const group of groups) {
			const id = group.stationId;

			if (!id || seen.has(id)) continue;

			seen.add(id);

			if ($.get(stationCoords)[id] ?? getCachedCoords(id)) continue;

			getStationCoords(id, group.stopName, group.apiProvider ?? "mvg", (c) => {
				$.set(stationCoords, { ...$.get(stationCoords), [id]: c }, true);
			});
		}
	});

	/** Google Maps search URL for stop location (GPS when available, else name). No tracking params. */
	function getMapsUrl(group) {
		const coords = $.get(stationCoords)[group.stationId] ?? getCachedCoords(group.stationId);

		if (coords) {
			return `https://www.google.com/maps/search/?api=1&query=${coords.lat},${coords.lng}`;
		}

		if (group.latitude != null && group.longitude != null) {
			return `https://www.google.com/maps/search/?api=1&query=${group.latitude},${group.longitude}`;
		}

		return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(group.stopName)}`;
	}

	function getRouteIconDisplay() {
		// Default to "icon_with_text" (matches Python default)
		return display()?.routeIconDisplay ?? "icon_with_text";
	}

	function getTransportTypeCss(transportType) {
		const map = {
			"U-Bahn": "ubahn",
			"S-Bahn": "sbahn",
			Bus: "bus",
			Tram: "tram",
			Bahn: "train"
		};

		return map[transportType] || "regional";
	}

	function formatDateTime(date) {
		// SPA runs in browser only: show local time as "YYYY-MM-DD HH:MM"
		const year = date.getFullYear();

		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		const hours = String(date.getHours()).padStart(2, "0");
		const minutes = String(date.getMinutes()).padStart(2, "0");

		return `${year}-${month}-${day} ${hours}:${minutes}`;
	}

	// Update datetime every second (matches Python: setInterval(updateDateTime, 1000))
	let currentDateTime = $.state($.proxy(formatDateTime(new Date())));

	onMount(() => {
		const interval = setInterval(
			() => {
				$.set(currentDateTime, formatDateTime(new Date()), true);
			},
			1000
		);

		return () => clearInterval(interval);
	});

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_5 = ($$anchor) => {
			var div = root_3();
			var node_1 = $.child(div);

			{
				var consequent = ($$anchor) => {
					var div_1 = root_1();

					$.each(div_1, 20, statusMessages, (message) => message, ($$anchor, message) => {
						var div_2 = root();
						var text = $.only_child(div_2, true);

						$.template_effect(() => $.set_text(text, message));
						$.append($$anchor, div_2);
					});

					$.reset(div_1);
					$.append($$anchor, div_1);
				};

				$.if(node_1, ($$render) => {
					if (statusMessages().length > 0) $$render(consequent);
				});
			}

			var node_2 = $.sibling(node_1, 2);

			{
				var consequent_2 = ($$anchor) => {
					var div_3 = root_2();
					var div_4 = $.child(div_3);
					var text_1 = $.only_child(div_4, true);
					var node_3 = $.sibling(div_4, 2);

					{
						var consequent_1 = ($$anchor) => {
							var div_5 = root();
							var text_2 = $.only_child(div_5, true);

							$.template_effect(($0) => $.set_text(text_2, $0), [() => describeRetryWait(progress().retryWait)]);
							$.append($$anchor, div_5);
						};

						$.if(node_3, ($$render) => {
							if (progress().retryWait) $$render(consequent_1);
						});
					}

					$.reset(div_3);
					$.template_effect(($0) => $.set_text(text_1, $0), [() => describeFetchProgress(progress())]);
					$.append($$anchor, div_3);
				};

				var consequent_4 = ($$anchor) => {
					var fragment_1 = $.comment();
					var node_4 = $.first_child(fragment_1);

					{
						var consequent_3 = ($$anchor) => {
							var text_3 = $.text();

							$.template_effect(($0) => $.set_text(text_3, `${$0 ?? ''} API provider${unsupportedProviders().length > 1 ? "s are" : " is"} not yet implemented in this version.`), [() => unsupportedProviders().join(" and ")]);
							$.append($$anchor, text_3);
						};

						var alternate = ($$anchor) => {
							var text_4 = $.text('No departures available');

							$.append($$anchor, text_4);
						};

						$.if(node_4, ($$render) => {
							if (unsupportedProviders().length > 0) $$render(consequent_3); else $$render(alternate, -1);
						});
					}

					$.append($$anchor, fragment_1);
				};

				$.if(node_2, ($$render) => {
					if (progress()) $$render(consequent_2); else if (statusMessages().length === 0) $$render(consequent_4, 1);
				});
			}

			$.reset(div);
			$.append($$anchor, div);
		};

		var alternate_6 = ($$anchor) => {
			var fragment_3 = $.comment();
			var node_5 = $.first_child(fragment_3);

			$.each(node_5, 17, groupedDepartures, $.index, ($$anchor, group, groupIndex) => {
				var div_6 = root_18();
				var h2 = $.child(div_6);
				var node_6 = $.child(h2);

				{
					var consequent_6 = ($$anchor) => {
						var fragment_4 = root_4();
						var span = $.first_child(fragment_4);
						var a = $.child(span);
						var text_5 = $.only_child(a, true);

						$.reset(span);

						var div_7 = $.sibling(span, 2);
						var text_6 = $.only_child(div_7, true);

						$.template_effect(
							($0, $1) => {
								$.set_attribute(a, 'href', $0);
								$.set_attribute(a, 'aria-label', `Open ${$.get(group).stopName ?? ''} in Google Maps`);
								$.set_text(text_5, $1);
								$.set_attribute(div_7, 'aria-label', `Current date and time: ${$.get(currentDateTime) ?? ''}`);
								$.set_text(text_6, $.get(currentDateTime));
							},
							[
								() => getMapsUrl($.get(group)),
								() => getHeaderText($.get(group))
							]
						);

						$.append($$anchor, fragment_4);
					};

					var alternate_1 = ($$anchor) => {
						var a_1 = root_5();
						var text_7 = $.only_child(a_1, true);

						$.template_effect(
							($0, $1) => {
								$.set_attribute(a_1, 'href', $0);
								$.set_attribute(a_1, 'aria-label', `Open ${$.get(group).stopName ?? ''} in Google Maps`);
								$.set_text(text_7, $1);
							},
							[
								() => getMapsUrl($.get(group)),
								() => getHeaderText($.get(group))
							]
						);

						$.append($$anchor, a_1);
					};

					$.if(node_6, ($$render) => {
						if (groupIndex === 0) $$render(consequent_6); else $$render(alternate_1, -1);
					});
				}

				$.reset(h2);

				var node_7 = $.sibling(h2, 2);

				{
					var consequent_7 = ($$anchor) => {
						var div_8 = root_6();
						var div_9 = $.child(div_8);
						var text_8 = $.only_child(div_9, true);

						$.reset(div_8);
						$.template_effect(() => $.set_text(text_8, $.get(group).refreshFailed ? "No data (refresh failed)" : "No departures"));
						$.append($$anchor, div_8);
					};

					var alternate_5 = ($$anchor) => {
						var ul = root_17();

						$.each(ul, 21, () => $.get(group).departures, $.index, ($$anchor, departure) => {
							var li = root_16();
							var div_10 = $.child(li);
							var span_1 = $.child(div_10);
							var node_8 = $.child(span_1);

							{
								var consequent_12 = ($$anchor) => {
									var fragment_5 = root_12();
									var node_9 = $.first_child(fragment_5);

									{
										var consequent_8 = ($$anchor) => {
											var svg = root_7();

											$.append($$anchor, svg);
										};

										var consequent_9 = ($$anchor) => {
											var svg_1 = root_8();

											$.append($$anchor, svg_1);
										};

										var consequent_10 = ($$anchor) => {
											var svg_2 = root_9();

											$.append($$anchor, svg_2);
										};

										var consequent_11 = ($$anchor) => {
											var svg_3 = root_10();

											$.append($$anchor, svg_3);
										};

										var alternate_2 = ($$anchor) => {
											var svg_4 = root_11();

											$.append($$anchor, svg_4);
										};

										$.if(node_9, ($$render) => {
											if ($.get(departure).transportType === "U-Bahn") $$render(consequent_8); else if ($.get(departure).transportType === "S-Bahn") $$render(consequent_9, 1); else if ($.get(departure).transportType === "Tram") $$render(consequent_10, 2); else if ($.get(departure).transportType === "Bahn") $$render(consequent_11, 3); else $$render(alternate_2, -1);
										});
									}

									var span_2 = $.sibling(node_9, 2);
									var text_9 = $.only_child(span_2, true);

									$.template_effect(() => $.set_text(text_9, $.get(departure).line));
									$.append($$anchor, fragment_5);
								};

								var d = $.derived(() => getRouteIconDisplay() === "icon_with_text");

								var consequent_13 = ($$anchor) => {
									var span_3 = root_13();
									var text_10 = $.only_child(span_3, true);

									$.template_effect(
										($0) => {
											$.set_class(span_3, 1, `route-badge route-badge-${$0 ?? ''}`, 'svelte-1apnbj7');
											$.set_text(text_10, $.get(departure).line);
										},
										[() => getTransportTypeCss($.get(departure).transportType)]
									);

									$.append($$anchor, span_3);
								};

								var d_1 = $.derived(() => getRouteIconDisplay() === "badge");

								var alternate_3 = ($$anchor) => {
									var text_11 = $.text();

									$.template_effect(() => $.set_text(text_11, $.get(departure).line));
									$.append($$anchor, text_11);
								};

								$.if(node_8, ($$render) => {
									if ($.get(d)) $$render(consequent_12); else if ($.get(d_1)) $$render(consequent_13, 1); else $$render(alternate_3, -1);
								});
							}

							$.reset(span_1);

							var span_4 = $.sibling(span_1, 2);
							var span_5 = $.child(span_4);
							var text_12 = $.only_child(span_5, true);

							$.reset(span_4);
							$.reset(div_10);

							var div_11 = $.sibling(div_10, 2);
							var span_6 = $.child(div_11);
							let classes;
							var text_13 = $.only_child(span_6, true);
							var span_7 = $.sibling(span_6, 2);
							var node_10 = $.child(span_7);

							{
								var consequent_15 = ($$anchor) => {
									var fragment_7 = root_15();
									var text_14 = $.first_child(fragment_7);
									var node_11 = $.sibling(text_14);

									{
										var consequent_14 = ($$anchor) => {
											var span_8 = root_14();
											var text_15 = $.only_child(span_8);

											$.template_effect(($0) => $.set_text(text_15, `+${$0 ?? ''}m`), [() => getDelayMinutes($.get(departure))]);
											$.append($$anchor, span_8);
										};

										var d_2 = $.derived(() => getDelayMinutes($.get(departure)));

										$.if(node_11, ($$render) => {
											if ($.get(d_2)) $$render(consequent_14);
										});
									}

									$.template_effect(($0) => $.set_text(text_14, `${$0 ?? ''} `), [() => formatPlannedTimeRelative($.get(departure))]);
									$.append($$anchor, fragment_7);
								};

								var alternate_4 = ($$anchor) => {
									var text_16 = $.text();

									$.template_effect(($0) => $.set_text(text_16, $0), [() => formatTimeRelative($.get(departure))]);
									$.append($$anchor, text_16);
								};

								$.if(node_10, ($$render) => {
									if (display()?.splitShowDelay) $$render(consequent_15); else $$render(alternate_4, -1);
								});
							}

							$.reset(span_7);
							$.reset(div_11);

							var span_9 = $.sibling(div_11, 2);
							var text_17 = $.only_child(span_9);

							$.reset(li);

							$.template_effect(
								($0, $1, $2, $3, $4, $5, $6) => {
									$.set_class(li, 1, `departure-row ${$.get(departure).isCancelled ? 'cancelled' : ''} ${$0 ?? ''}`, 'svelte-1apnbj7');
									$.set_attribute(li, 'aria-label', `${$.get(departure).transportType ?? ''} ${$.get(departure).line ?? ''} to ${$.get(departure).destination ?? ''}, ${$1 ?? ''}`);
									$.set_text(text_12, $.get(departure).destination);
									$.set_attribute(div_11, 'data-time-relative', $2);
									$.set_attribute(div_11, 'data-time-absolute', $3);
									classes = $.set_class(span_6, 1, 'platform svelte-1apnbj7', null, classes, { stand: $4 });
									$.set_text(text_13, $.get(departure).platform || $.get(departure).stopPosition || "");
									$.set_class(span_7, 1, `time ${$5 ?? ''} ${$.get(departure).isRealtime ? 'realtime' : ''}`, 'svelte-1apnbj7');
									$.set_text(text_17, `${$.get(departure).transportType ?? ''} ${$.get(departure).line ?? ''} to ${$.get(departure).destination ?? ''}, ${$6 ?? ''}`);
								},
								[
									() => showsStaleTimes($.get(group)) ? 'stale' : '',
									() => formatTimeRelative($.get(departure)),
									() => display()?.splitShowDelay
										? formatPlannedTimeRelative($.get(departure))
										: formatTimeRelative($.get(departure)),

									() => display()?.splitShowDelay
										? formatPlannedTimeAbsolute($.get(departure))
										: formatTimeAbsolute($.get(departure)),
									() => !$.get(departure).platform && Boolean($.get(departure).stopPosition),
									() => hasDelay($.get(departure)) ? 'delay' : '',
									() => formatTimeRelative($.get(departure))
								]
							);

							$.append($$anchor, li);
						});

						$.reset(ul);
						$.template_effect(($0) => $.set_attribute(ul, 'aria-label', $0), [() => rowListLabel($.get(group))]);
						$.append($$anchor, ul);
					};

					$.if(node_7, ($$render) => {
						if ($.get(group).departures.length === 0) $$render(consequent_7); else $$render(alternate_5, -1);
					});
				}

				$.reset(div_6);

				$.template_effect(() => {
					$.set_style(h2, groupIndex === 0
						? undefined
						: $.get(group).headerColor
							? `background-color: ${$.get(group).headerColor};`
							: undefined);

					$.set_attribute(h2, 'data-fill-vertical-space', display()?.fillVerticalSpace && groupIndex === 0 ? "true" : undefined);
				});

				$.append($$anchor, div_6);
			});

			$.append($$anchor, fragment_3);
		};

		$.if(node, ($$render) => {
			if (groupedDepartures().length === 0) $$render(consequent_5); else $$render(alternate_6, -1);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}